// GraphClipboardStatus — the transient pill that says what a copy/cut/paste did.
//
// Rendered INSIDE the graph canvas, bottom-centre, because the proximity rule
// puts feedback next to the thing it describes rather than in a global status
// bar. Both graph editors mount it from the same useGraphClipboard state, so a
// refusal reads identically wherever it happens.
//
// It exists because the alternative — a chord that silently does nothing — is
// indistinguishable from a broken feature. That includes the SUCCESS case: a
// paste that lands off-screen with no message reads as a no-op.

const LEVEL_COLOR = {
  info: 'var(--m-text)',
  warn: 'var(--m-warn)',
  error: 'var(--m-error, var(--m-warn))',
}

export default function GraphClipboardStatus({ status }) {
  if (!status?.message) return null
  return (
    <div
      data-testid="graph-clipboard-status"
      data-level={status.level}
      style={{
        position: 'absolute',
        bottom: 14,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '80%',
        zIndex: 20,
        pointerEvents: 'none',   // never in the way of the canvas underneath
        padding: '6px 12px',
        borderRadius: 4,
        border: `1px solid ${status.level === 'info' ? 'var(--m-line)' : LEVEL_COLOR[status.level]}`,
        background: 'var(--m-panel)',
        color: LEVEL_COLOR[status.level] ?? LEVEL_COLOR.info,
        font: '11px/1.45 var(--m-font)',
        letterSpacing: '.02em',
        textAlign: 'center',
        boxShadow: '0 2px 10px rgba(0,0,0,.35)',
      }}
    >
      {status.message}
    </div>
  )
}
